// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"dcd42d37","212":"9fc9b207","228":"a93554db","363":"7f7fb95f","530":"f7ef5e2c","638":"57ba953a","757":"9756cf50"}[chunkId] + ".chunk.js";
};